import { common } from '@local/web-design-system/styles/common';
import type { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

/*
variant is being used to determine the color of this component. relying on lightmode or darkmode was not applicable for this component and the color schemes it should take
*/
export const useStyles = makeStyles<{
    variant: string;
    width: number | undefined;
    topSpacing: number | undefined;
}>()((theme: Theme, { variant, width, topSpacing }) => ({
    selectMenu: {
        backgroundColor: variant === 'light' ? theme.palette.common.white : theme.palette.grey[100],
        height: theme.spacing(4.5),
        fontSize: '14px',
        color: variant === 'light' ? theme.palette.common.white : theme.palette.common.black,
    },
    selectMenuButton: {
        height: theme.spacing(8),
        color: theme.palette.common.white,
        '&:hover': {
            backgroundColor:
                variant === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
        },
        '&:active': {
            backgroundColor:
                variant === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
        },
        '&:focus': {
            backgroundColor:
                variant === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
        },
    },
    selectPaper: {
        ...common(theme).thinScrollBar,
        maxWidth: width ? `${width}px` : 'auto',
        maxHeight: theme.spacing(45),
        backgroundColor: variant === 'light' ? theme.palette.common.white : '#1D1F23',
        marginTop: topSpacing ? theme.spacing(topSpacing) : theme.spacing(8),
        boxShadow: '0 1px 6px 0 rgba(29, 31, 35, 0.13)',
        border: '0px',
        overflowX: 'hidden',
        '& hr': {
            borderTop: variant === 'light' ? `1px solid #ebebeb` : 'none',
        },
    },
    selectMenuLabel: {
        backgroundColor: variant === 'light' ? theme.palette.secondary.contrastText : '#1d1f23',
        borderTop: variant === 'light' ? 'none' : theme.palette.grey[400],
        color: variant === 'light' ? theme.palette.common.black : theme.palette.common.white,
        letterSpacing: '0.4px',
        cursor: 'default',
        width: '100%',
        display: 'inline-block',
        marginBottom: theme.spacing(-0.5),
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        '& .option': {
            color: theme.palette.grey[400],
        },
    },
    selectMenuItem: {
        backgroundColor: variant === 'light' ? theme.palette.common.white : '#39393C',
        color: variant === 'light' ? '#265C7F' : theme.palette.common.white,
        '& .optionGroup': {
            display: 'none',
        },
        '& .option': {
            width: width ? `${width - 40}px` : 'auto',
            display: 'inline-block',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
    },
    labelContainer: {
        color: variant === 'light' ? '#39393C' : theme.palette.common.white,
        height: 'fit-content',
        '& .optionGroup': {
            fontSize: '12px',
            width: width ? `${width - 65}px` : 'auto',
            display: 'inline-block',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
        '& .option': {
            color: theme.palette.grey[400],
            fontSize: '11px',
            width: width ? `${width - 65}px` : 'auto',
            display: 'inline-block',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
    textAlign: {
        textAlign: 'start',
    },
}));
